import { Card, CardActionArea, Stack, Typography } from '@common/components'
import { useSearchParams } from '@lib/router'
import React from 'react'

const ResourcesTopicsView = () => {
  const [searchParams, setSearchParams] = useSearchParams()
  const selectedTopic = searchParams.get('topic') || 'ideation'
  const topics = [
    'Ideation',
    'Organisation and Development',
    'Pronunciation and Fluency',
    'Grammar',
    'Vocabulary',
  ]
  return (
    <Stack spacing={2} sx={{ height: '100%', width: '100%' }}>
      <Typography fontWeight={600}>Topics</Typography>
      {topics.map((topic) => (
        <TopicCard
          key={topic}
          topic={topic}
          isSelected={selectedTopic?.toLowerCase() === topic.toLowerCase()}
          onClick={() => setSearchParams({ topic: topic.toLowerCase() })}
        />
      ))}
    </Stack>
  )
}

const TopicCard = ({
  topic,
  isSelected,
  onClick,
}: {
  topic: string
  isSelected: boolean
  onClick: () => void
}) => {
  return (
    <Card>
      <CardActionArea
        onClick={onClick}
        sx={{
          p: 2,
          backgroundColor: isSelected ? '#3f61c430' : 'transparent',
          border: isSelected ? '1px solid #3f61c4' : 'none',
        }}
      >
        <Typography align='center' fontWeight={550}>
          {topic}
        </Typography>
      </CardActionArea>
    </Card>
  )
}

export default ResourcesTopicsView
